(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glowup-bento"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('glowup-bento'))customElements.define('glowup-bento',class extends HTMLElement{
connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.querySelectorAll('.gmb__card').forEach(card=>card.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse'||this.dataset.motion==='false'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const r=card.getBoundingClientRect();card.style.setProperty('--spot-x',(e.clientX-r.left)+'px');card.style.setProperty('--spot-y',(e.clientY-r.top)+'px');}));}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowup-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glowup-collection')) {
  customElements.define('glowup-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const form = this.querySelector('.gcl__sort');
      if (form) form.querySelector('select').addEventListener('change', () => form.requestSubmit());
      this.dataset.ready = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowup-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('glowup-compare'))customElements.define('glowup-compare',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;
const frame=this.querySelector('.gmc__frame'),input=this.querySelector('.gmc__range');
if(!frame||!input)return;
const update=value=>{input.value=String(Math.round(Math.max(0,Math.min(100,value))));frame.style.setProperty('--compare-position',input.value+'%');};
input.addEventListener('input',()=>update(input.value));
let pointer=null;
const position=e=>{const r=frame.getBoundingClientRect();update((e.clientX-r.left)/r.width*100);};
frame.addEventListener('pointerdown',e=>{if(!e.isPrimary||e.button!==0)return;pointer=e.pointerId;frame.setPointerCapture(pointer);position(e);input.focus({preventScroll:true});});
frame.addEventListener('pointermove',e=>{if(pointer===e.pointerId)position(e);});
const end=e=>{if(pointer!==e.pointerId)return;if(frame.hasPointerCapture(pointer))frame.releasePointerCapture(pointer);pointer=null;};
frame.addEventListener('pointerup',end);frame.addEventListener('pointercancel',end);
this.dataset.ready='true';update(50);
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowup-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('glowup-editorial'))customElements.define('glowup-editorial',class extends HTMLElement{
connectedCallback(){if(this.observer)return;this.observer=new IntersectionObserver(entries=>entries.forEach(e=>e.target.toggleAttribute('data-visible',e.isIntersecting)),{threshold:.15});this.querySelectorAll('.ge__story').forEach(e=>this.observer.observe(e));}
disconnectedCallback(){if(this.observer){this.observer.disconnect();this.observer=null;}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowup-service-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glowup-service-hub')) {
  customElements.define('glowup-service-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length) return;
      this.querySelector('.gsh__nav').setAttribute('role','tablist');
      this.tabs.forEach((tab,index) => {
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls',this.panels[index].id);
        this.panels[index].setAttribute('role','tabpanel');
        tab.addEventListener('click',event => { event.preventDefault(); this.select(index); });
        tab.addEventListener('keydown',event => {
          let next=index;
          if (event.key==='ArrowRight') next=(index+1)%this.tabs.length;
          else if (event.key==='ArrowLeft') next=(index+this.tabs.length-1)%this.tabs.length;
          else if (event.key==='Home') next=0;
          else if (event.key==='End') next=this.tabs.length-1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        });
      });
      this.addEventListener('shopify:block:select',event => {
        const index=this.tabs.findIndex(tab => tab.dataset.tab===event.detail.blockId);
        if (index>=0) this.select(index);
      });
      this.indicator=this.querySelector('.gsh__indicator');
      this.resizeObserver=new ResizeObserver(()=>this.syncIndicator());
      this.resizeObserver.observe(this.querySelector('.gsh__nav'));
      this.querySelectorAll('.gsh__card').forEach(card=>{
        card.addEventListener('pointermove',event=>{
          if(event.pointerType!=='mouse'||this.dataset.motion==='false'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
          const rect=card.getBoundingClientRect();
          card.style.setProperty('--spot-x',(event.clientX-rect.left)+'px');
          card.style.setProperty('--spot-y',(event.clientY-rect.top)+'px');
        });
      });
      this.select(0);
      this.dataset.ready='true';
    }
    disconnectedCallback(){if(this.resizeObserver)this.resizeObserver.disconnect();}
    syncIndicator(){
      const tab=this.tabs[this.activeIndex||0];
      if(!tab||!this.indicator)return;
      this.indicator.style.width=tab.offsetWidth+'px';
      this.indicator.style.height=tab.offsetHeight+'px';
      this.indicator.style.transform='translateX('+tab.offsetLeft+'px)';
    }
    select(index) {
      const previous=this.activeIndex;
      this.activeIndex=index;
      this.dataset.active=this.tabs[index].dataset.platform;
      this.tabs.forEach((tab,i) => {
        tab.setAttribute('aria-selected',String(i===index));
        tab.tabIndex=i===index?0:-1;
        this.panels[i].hidden=i!==index;
      });
      this.syncIndicator();
      if(previous!==undefined&&previous!==index&&this.dataset.motion!=='false'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
        if(this.panelAnimation)this.panelAnimation.cancel();
        this.panelAnimation=this.panels[index].animate([{opacity:.15,transform:'translateY(10px) scale(.992)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowup-social-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('.glowup-hero__button[href^="#"]');
  if(!button||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const href=button.getAttribute('href');
  const target=document.getElementById(href.slice(1))||(href.startsWith('#GlowServices-')?document.querySelector('glowup-service-hub'):null);
  if(!target)return;
  event.preventDefault();
  event.stopPropagation();
  const top=Math.max(0,target.getBoundingClientRect().top+window.scrollY-84);
  window.scrollTo({top,behavior:'instant'});
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
